import * as React from 'react';

import {useState, useEffect} from 'react';
import {TouchableOpacity, View} from 'react-native';
import {useStyles} from '../../../shared/hooks/styles';
import {images} from '../../../assets/icons';
import {Text} from '../../../shared/components/text';
import {DeviceSize} from '../../../shared/theme/helpers';

interface CountDownTimerProps {
  onRefresh?: () => void;
  onTimerEnd?: () => void;
  until: number;
  fallbackContent?: React.ReactElement;
}

export interface CountDownTimerRefProps {
  resetTimer: () => void;
}

export const CountDownTimer = React.forwardRef<CountDownTimerRefProps, CountDownTimerProps>(
  ({onRefresh, onTimerEnd, until}, ref) => {
    const [time, setTime] = useState(until);
    React.useImperativeHandle<CountDownTimerRefProps, CountDownTimerRefProps>(
      ref,
      () => ({
        resetTimer: () => setTime(until),
      }),
      [until],
    );
    const styles = useStyles(({theme, mediaOnly}) => {
      return {
        lbl: {
          ...mediaOnly(DeviceSize.desktop, theme.fonts.body, theme.fonts.label),
          color: theme.color.gray500,
          textAlign: 'center',
          marginTop: 12,
        },
        dummy: {
          height: (theme.fonts.label.lineHeight || 0) + 12,
        },
        repeatText: {
          ...mediaOnly(DeviceSize.desktop, theme.fonts.body, theme.fonts.bodySmallLight),
          color: theme.color.primaryColor,
          marginLeft: 8,
        },
        repeatContainer: {
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'center',
          alignItems: 'center',
          marginTop: 12,
          color: theme.color.primaryColor,
        },
      };
    });
    useEffect(() => {
      setTime(until);
    }, [until]);

    useEffect(() => {
      let timer: any;
      if (time > 0) {
        timer = setTimeout(() => {
          decrementClock();
        }, 1000);
      } else {
        if (onTimerEnd) onTimerEnd();
      }
      return () => {
        clearTimeout(timer);
      };
    }, [time]);

    const decrementClock = () => {
      setTime(time - 1);
    };

    return time <= 0 ? (
      onRefresh ? (
        <TouchableOpacity
          testID='get-code-more-id'
          style={styles.repeatContainer}
          onPress={() => {
            try {
              onRefresh();
              setTime(until);
            } catch (err) {}
          }}>
          <images.Refresh width={16} height={16} color={styles.repeatText.color} />
          <Text style={styles.repeatText}>Получить код повторно</Text>
        </TouchableOpacity>
      ) : (
        <View style={styles.dummy} />
      )
    ) : (
      <Text style={styles.lbl}>Получить код повторно через {time} сек</Text>
    );
  },
);
